module.exports = __webpack_public_path__ + "img/46f9d1df658ac8df7e9be8b8d4dcffdf.png";